<template>
  <div class="primary--text">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="caption">
          {{ valorIndicador.indicador.nombre }}
          <span v-if="valorIndicador.norma">, Norma:</span>{{ valorIndicador.norma }}
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6">
        <v-select v-model="tipoSeleccionado" item-value="valor" item-text="texto" :items="tiposPosibles"
                  @change="cambiaTipo()">
        </v-select>
      </v-col>
      <v-col cols="6">
        <div v-if="valorIndicador.clases.length > 0" v-show="tipoSeleccionado === 'clase'"
             class="small-6 columns">
          <v-select v-model="claseSelecionada" @change="cambiaClase()" :items="valorIndicador.clases"
                    :item-text="calcularOpcionClaseTexto"
          ></v-select>
        </div>
        <div v-show="tipoSeleccionado === 'rango'" @change="cambiaRango()"
             class="small-6 columns">
          <v-text-field v-model="rango" type="number" placeholder="Introduce un valor"></v-text-field>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "IndicadorPrestacional",
  props: {
    valorIndicador: {type: Object, required: true},
    solucionConstructivaPrestacion: {type: Object, required: true},
  },
  data: function () {
    return {
      tipoSeleccionado: null,
      claseSelecionada: null,
      rango: null
    }
  },
  mounted() {
    this.inicializarSeleccion();
  },
  watch: {
    solucionConstructivaPrestacion: {
      handler() {
        this.inicializarSeleccion();
      },
      deep: true
    },
  },
  computed: {
    tiposPosibles: function () {
      let tipos = [];

      if (this.valorIndicador.rango || this.valorIndicador.opciones.length === 0) {
        tipos.push({
          valor: "rango",
          texto: `Introduce un valor (${this.valorIndicador.unidades})`
        });
      }

      this.valorIndicador.opciones.forEach((opcion) => {
        tipos.push({
          valor: opcion,
          texto: this.calcularOpcionTexto(opcion)
        });
      });

      return tipos;
    }
  },
  methods: {
    inicializarSeleccion() {
      let codigo = this.valorIndicador.indicador.codigo;
      let valorDefecto =
          Object.prototype.hasOwnProperty.call(this.solucionConstructivaPrestacion.parametros, codigo)
              ? this.solucionConstructivaPrestacion.parametros[codigo] : this.valorIndicador.valorDefecto;
      this.seleccionarValorDefecto(this.valorIndicador, valorDefecto);
    },
    calcularOpcionTexto(option) {
      switch (option.trim().toLowerCase()) {
        case "dnd":
          return "Dato no disponible";
        case "dna":
          return "Dato no aplicable";
        case "clase":
          return "Selecciona una clase";
        default:
          return option;
      }
    },
    calcularOpcionClaseTexto(option) {
      let optionFormatted = option.trim().toLowerCase();
      let text = '';

      switch (optionFormatted) {
        case "dnd":
          return "Clase no disponible";
        case "dna":
          return "Clase no aplicable";
        case "clase":
          return "Selecciona una clase";
        default:
          text =
              !optionFormatted.includes('no requiere ensayo')
              && optionFormatted !== 'si'
              && optionFormatted !== 'no'
              && optionFormatted !== 'si*'
              && optionFormatted !== 'no*'
              && !optionFormatted.includes('cumple')
                  ? "" : "";

          return text + option;
      }
    },
    seleccionarValorDefecto(indicador, valorDefecto) {
      let valor = null;
      let encontradoEnClases = false;
      indicador.clases.forEach((clase) => {
        if (valorDefecto.trim().toLowerCase() == clase.trim().toLowerCase()) {
          valor = clase;
          encontradoEnClases = true;
        }
      });

      let encontradoEnOpciones = false;
      indicador.opciones.forEach((opcion) => {
        if (valorDefecto.trim().toLowerCase() == opcion.trim().toLowerCase()) {
          valor = opcion;
          encontradoEnOpciones = true;
        }
      });

      if (encontradoEnClases) {
        this.tipoSeleccionado = 'clase';
        this.claseSelecionada = valor;
      } else if (encontradoEnOpciones) {
        this.tipoSeleccionado = valor;
      } else if (indicador.rango || indicador.opciones.length === 0) {
        this.tipoSeleccionado = 'rango';
        this.rango = Number(valorDefecto.replace(",", "."));
      }
    },
    esRangoPorDefecto(range) {
      try {
        // noinspection EqualityComparisonWithCoercionJS
        return Number(range) == Number(this.valorIndicador.valorDefecto.replace(",", "."));
      } catch (e) {
        return false;
      }
    },
    esClasePorDefecto(classe) {
      return classe.trim().toLowerCase() === this.valorIndicador.valorDefecto.trim().toLowerCase();
    },
    cambiaTipo() {
      this.eliminarPrestacion();

      if (this.tipoSeleccionado === this.valorIndicador.valorDefecto) return;

      switch (this.tipoSeleccionado) {
        case "rango":
          if (this.rango !== null && !this.esRangoPorDefecto(this.rango)) this.asignarPrestacion(this.rango);
          break;
        case "clase":
          if (this.claseSelecionada !== null && !this.esClasePorDefecto(this.claseSelecionada))
            this.asignarPrestacion(this.claseSelecionada);
          break;
        default:
          this.asignarPrestacion(this.tipoSeleccionado);
      }
    },
    cambiaClase() {
      if (this.esClasePorDefecto(this.claseSelecionada))
        this.eliminarPrestacion();
      else
        this.asignarPrestacion(this.claseSelecionada);
    },
    cambiaRango() {
      if (this.esRangoPorDefecto(this.rango))
        this.eliminarPrestacion();
      else
        this.asignarPrestacion(this.rango);
    },
    asignarPrestacion(value) {
      let codigo = this.valorIndicador.indicador.codigo;
      this.solucionConstructivaPrestacion.parametros[codigo] = value;
    },
    eliminarPrestacion() {
      let codigo = this.valorIndicador.indicador.codigo;
      delete this.solucionConstructivaPrestacion.parametros[codigo];
    }
  }
}
</script>

<style>

</style>